import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Logo from './Logo.vue'
import FullScreen from './FullScreen.vue'
import UserInfo from './UserInfo.vue'
import Menus from './Menus.vue'
import Task from './Task.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_el_space = _resolveComponent("el-space")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_space, { size: "large" }, {
      default: _withCtx(() => [
        _createVNode(Logo, { class: "logo_name_header" }),
        _createVNode(Menus)
      ]),
      _: 1
    }),
    _createVNode(_component_el_space, { size: "small" }, {
      default: _withCtx(() => [
        _createVNode(Task),
        _createVNode(FullScreen),
        _createVNode(UserInfo)
      ]),
      _: 1
    })
  ], 64))
}
}

})